import { HttpClient } from '@angular/common/http';
// import { environment } from '../../../../environments/environment';
import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../config/config.service";
var HelpHttpService = /** @class */ (function () {
    function HelpHttpService(http, configService) {
        this.http = http;
        this.configService = configService;
        this.apiName = this.configService.get('host');
    }
    // getMachines(queryParams) {
    // 	return new Observable((observer: any) => {
    // 		const path = '/dashboard/get_all_macs';
    // 		const myInit = {
    // 			response: false,
    // 			queryStringParameters: queryParams
    // 		};
    // 		API.get(this.apiName, path, myInit).then(response => {
    // 		  observer.next(response.data);
    // 		}).catch(err => {
    // 			console.log(err.response);
    // 			observer.error(err);
    // 		});
    // 	});
    // }
    HelpHttpService.prototype.getHelpFeedback = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_help_feedback';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    HelpHttpService.prototype.getHelpRemarks = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_help_remarks';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    HelpHttpService.prototype.saveRemarks = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/save_remarks';
            var params = {
                body: formObj
            };
            API.post(_this.apiName, path, params).then(function (resp) {
                observer.next(resp);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    HelpHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HelpHttpService_Factory() { return new HelpHttpService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: HelpHttpService, providedIn: "root" });
    return HelpHttpService;
}());
export { HelpHttpService };
